import React, { useEffect, useState } from 'react';
import { CardContent, CardHeader, Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Card, FormControl, InputLabel, InputAdornment, IconButton, OutlinedInput, ListItemSecondaryAction, useMediaQuery } from '@material-ui/core';
import { useHistory, useParams } from 'react-router';
import Swal from 'sweetalert2';
import { MapGiz } from '../../helpers';
import { Delete, Search } from '@material-ui/icons';
import Form from './Form';

import InfiniteScroll from 'react-infinite-scroll-component';
import { panelHeight } from './List';
export const TablaOqt = ({rows, columns, data, id, term, onChangeTerm, onLoadMore, onRefresh, infiniteScroll, hasMore, onDeleteClick, onItemClick, showEndMessage}) => {


  const history = useHistory();

  const columnText = columns
    .filter(x => x.field !== "acciones")
    .map(c => <span style={{margin: 4, marginRight: 8}}>{c.headerName}</span> )
  

  return (
    <>

      <div  style={{padding: 16}}>
        {infiniteScroll && 
          <InfiniteScroll
            style={{display: "flex", flexDirection: "column"}}
            dataLength={rows.length} //This is important field to render the next data
            next={onLoadMore}
            hasMore={hasMore}
            loader={<h4>Cargando...</h4>}
            endMessage={
              <p style={{ textAlign: 'center', opacity: 0.4 }}>
                {showEndMessage && <b>No hay más items para cargar</b>}
                {rows.length === 0 && <b>No se encontraron elementos para mostrar</b>}
                
              </p>
            }
            // below props only if you need pull down functionality
            refreshFunction={onRefresh}
            pullDownToRefresh
            pullDownToRefreshThreshold={50}
            pullDownToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>&#8595; Tire para refrescar</h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: 'center' }}>&#8593; Suelte para refrescar</h3>
            }
            height={panelHeight-180}
          >
            {
              rows.map((row, index) => <ListItemOqt index={index} row={row} key={row.id} selected={`${id}` === `${row.id}`} columns={columns} onItemClick={onItemClick} onDeleteClick={onDeleteClick} />)
            }
          </InfiniteScroll>
        }

        {!infiniteScroll && 
          <div style={{display: "flex", flexDirection: "column", height: panelHeight-180, overflowY: "auto"}}>
            {
              rows.length === 0 
              ? <p style={{ textAlign: 'center', opacity: 0.4 }}><b>No se encontraron elementos para mostrar</b></p>
              : rows.map((row, index) => <ListItemOqt index={index} row={row} key={row.id} selected={`${id}` === `${row.id}`} columns={columns} onItemClick={onItemClick} onDeleteClick={onDeleteClick} />)
            }
          </div>
        }
      </div>


    </>
  )
}

export const ListItemOqt = ({index, selected, columns, row, onItemClick, onDeleteClick}) => {

  const primaryText = columns
    .filter(x => x.field !== "acciones")
    .map((c, index) => row[c.field])
    .join(", ");
  
  const removeText = columns
    .filter(x => x.field !== "acciones")
    .map((c, index) => row[c.field]).join(", ");

  return (
    <div  
      style={{
        minHeight: 40,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: selected ? "rgba(0, 0, 0, 0.09)" : "unset",
        color: selected ? "inherit" : "rgba(80, 80, 80, 0.67)",
        cursor: "pointer",
        userSelect: "none",
        padding: 4,
        borderTop: index > 0 ? "1px solid #f1f1f1" : "",
      }} 
      onClick={(event)=>onItemClick(row, event)}
    >
      <div style={{flex: 1}} className="text-gray-600 text-hover-primary mb-1" >
        <div style={{flex: 1, margin: 2, fontWeight: 600}}>{primaryText}</div>
      </div>
      {selected && onDeleteClick &&
        <div>
          <IconButton onClick={(event)=>onDeleteClick(event, row, removeText)} style={{padding: 6}}>
            <Delete style={{fill: "#d53e3e"}}/>
          </IconButton>
        </div>
      }
    </div>
  )
}

